import { render, staticRenderFns } from "./AutoOrganizeModal.vue?vue&type=template&id=9b6a1f14&scoped=true&"
import script from "./AutoOrganizeModal.vue?vue&type=script&lang=js&"
export * from "./AutoOrganizeModal.vue?vue&type=script&lang=js&"
import style0 from "./AutoOrganizeModal.vue?vue&type=style&index=0&id=9b6a1f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a1f14",
  null
  
)

export default component.exports